/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import DynamicStep from './DynamicStep';
import { FormControl, Stack, Typography } from '@mui/material';
import { formValues } from '../../utils/types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
DocumentData,
Timestamp,
collection,
getDocs,
} from 'firebase/firestore';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../../theme';
import { logEvent } from 'firebase/analytics';
import { analytics, db } from '../../firebase-setup/firebase';

const steps = [
'Qualification',
'Medications',
'Personal Details',
'Healthcare Provider',
'Confirmation',
];

function FormStepper({
medicationsList,
insuranceDataList,
isMedicareOnly,
source,
sessionId,
}: {
medicationsList: DocumentData[] | null;
insuranceDataList: DocumentData[] | null;
isMedicareOnly: boolean;
source: string;
sessionId: string;
}) {
const [activeStep, setActiveStep] = useState(0);
const [formValues, setFormValues] = useState<formValues>({
patient: {
timestamp: Timestamp.now(),
fname: '',
lname: '',
mname: '',
dob: '',
ssn: '',
address: '',
apt: '',
city: '',
state: '',
country: 'USA',
zip: '',
fullAddress: '',
phone: '',
email: '',
marital: '',
employed: '',
sex: 'Male',
disabled: 'no',
numinhouse: '',
emerContactName: '',
emerContactPhone: '',
income: '',
agentInfo: {
agentName: '',
agentPhone: '',
agentEmail: '',
agentId: '',
agentFYMId: '',
  // agentFYMAgency:'',
},
insurance: {
company: isMedicareOnly ? 'medicare' : '',
product: '',
plan: '',
policy: '',
},
medicare: {
partD: '',
advantage: 'no',
advantageCoverage: '',
supplement: '',
year: '2025',
mbi: '',
bothSSC: '',
spouceRecieveSSC: '',
medicareInfo: {
  medicareDate: '',
  insuranceName: '',
  planPhone: '',
  memberId: '',
  groupId: '',
  planStartDate: '',
  planEndDate: '',
},
pharmacyInfo: {
  rxInsuranceName: '',
  rxPlanPhone: '',
  pcn: '',
  bin: '',
  rxMemberId: '',
  rxGroupId: '',
  rxPlanStartDate: '',
  rxPlanEndDate: '',
  rxAddress: '',
  rxCity: '',
  rxState: '',
  rxZip: '',
},
},
medicareExtraDetails: {},
source: source,
reEnrollment: false,
},
doctors: [
{
fname: '',
mname: '',
lname: '',
phone: '',
fax: '',
faxValidate: '',
address: '',
city: '',
state: '',
zip: '',
fullAddress: '',
country: 'USA',
facility: '',
suite: '',
ext: '',
},
],
orders: [
{
doctorName: '',
medicationName: '',
medicationStrength: '',
medicationDelivery: '',
},
{
doctorName: '',
medicationName: '',
medicationStrength: '',
medicationDelivery: '',
},
{
doctorName: '',
medicationName: '',
medicationStrength: '',
medicationDelivery: '',
},
{
doctorName: '',
medicationName: '',
medicationStrength: '',
medicationDelivery: '',
},
],
agreements: {
incomeStatement: false,
policiesStatement: false,
informationStatement: false,
effectiveStatement: false,
},
});
const memoizedFormValues = useMemo(() => formValues, [formValues]);

useEffect(() => {
sessionStorage.setItem('formData', JSON.stringify(formValues));
}, [formValues]);

const matches = useMediaQuery('(max-width:991px)');

useEffect(() => {
logEvent(analytics, `form_step - ${activeStep}`);
const url = new URL(window.location.href);
url.searchParams.set('step', activeStep.toString());
window.history.pushState({}, '', url);
}, [activeStep]);

function fillValuesFromQueryParams() {
const url = new URL(window.location.href);
const searchParams = new URLSearchParams(url.search);
searchParams.forEach((value, key) => {
if (value === '') return;
if (key === 'company' && value === 'medicare') {
setFormValues((prev) => ({
  ...prev,
  patient: {
    ...prev.patient,
    insurance: {
      ...prev.patient.insurance,
      company: value,
    },
  },
}));
} else if (key === 'householdSize') {
setFormValues((prev) => ({
  ...prev,
  patient: {
    ...prev.patient,
    numinhouse: value,
  },
}));
} else if (key === 'income') {
setFormValues((prev) => ({
  ...prev,
  patient: {
    ...prev.patient,
    income: value.replace(/\D/g, ''),
  },
}));
} else if (key === 'medicationName') {
setFormValues((prev) => ({
  ...prev,
  orders: [
    {
      ...prev.orders[0],
      medicationName: value,
    },
    ...prev.orders.slice(1),
  ],
}));
}
});
}
useEffect(() => {
fillValuesFromQueryParams();
}, []);

//format phone number from FMY
function formatFYMPhoneNumber(number: string) {
number = number.replace(/\D/g, '');
const input = number.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
const areaCode = input.substring(0, 3);
const middle = input.substring(3, 6);
const last = input.substring(6, 10);

if (input.length > 6) {
number = `(${areaCode}) ${middle} - ${last}`;
} else if (input.length > 3) {
number = `(${areaCode}) ${middle}`;
} else if (input.length > 0) {
number = `(${areaCode}`;
}
return number;
}

// get Agent Info from message event (FYM)
useEffect(() => {
const handleMessage = (event: MessageEvent) => {
if (event.data?.type === 'AGENT_INFO') {
const formatedPhoneNumber = formatFYMPhoneNumber(
  event.data.payload.agentPhone || ''
);
setFormValues((prev) => ({
  ...prev,
  patient: {
    ...prev.patient,
    agentInfo: {
      agentName: event.data.payload.agentName || '',
      agentPhone: formatedPhoneNumber || '',
      agentEmail: event.data.payload.agentEmail || '',
      agentId: event.data.payload.agentNpn || '',
      agentFYMId: event.data.payload.agentId || ''
        // agentFYMAgency: event.data.payload.agentAgency || '',
    },
  },
}));
}
};

window.addEventListener('message', handleMessage);
return () => window.removeEventListener('message', handleMessage);
}, []);

//restore form values from older session
const fetchFirebaseData = useCallback(async (sessionId: string) => {
const sesionIdDB = sessionId.replace(/^(.{2})/, '$1.');
try {
const snapshot = await getDocs(collection(db, 'fymSessions'));
const matchingDoc = snapshot.docs.find((doc) => {
if (doc.data().uniqueId.includes(sesionIdDB)) return true;
});

if (matchingDoc) {
const data = matchingDoc.data();
setFormValues((prev) => ({
  ...prev,
  patient: {
    ...data.values.patient,
    timestamp: Timestamp.now(),
  },
  doctors: data.values.doctors,
  orders: data.values.orders,
  agreements: data.values.agreements,
}));
sessionStorage.setItem('uniqueId', data.uniqueId);
} else {
console.warn(
  'No matching document found for sessionId ending with:',
  sesionIdDB
);
}
} catch (error) {
console.error('Error fetching data from Firebase:', error);
}
}, []);

useEffect(() => {
if (!sessionId || sessionId === '') return;
fetchFirebaseData(sessionId);
}, [fetchFirebaseData, sessionId]);

return (
<Stack
sx={{ width: '100%' }}
gap={{
xs: 2,
md: 8,
}}>
{matches ? (
<Stack
  spacing={2}
  p={2}
  direction={'row'}
  justifyContent={'center'}
  alignItems={'center'}>
  <Stack
    justifyContent={'center'}
    alignItems={'center'}
    p={1}
    sx={{
      borderRadius: 99,
      backgroundColor: theme.palette.primary.main,
      width: 32,
      height: 32,
      color: 'white',
    }}>
    <Typography variant="body1" fontWeight={600}>
      {activeStep}
    </Typography>
  </Stack>
  <Typography variant="body1" fontWeight={600}>
    {steps[activeStep]}
  </Typography>
</Stack>
) : (
<Stepper activeStep={activeStep}>
  {steps.map((label) => {
    const stepProps: { completed?: boolean } = {};
    const labelProps: {
      optional?: React.ReactNode;
    } = {};
    return (
      <Step key={label} {...stepProps}>
        <StepLabel {...labelProps}>{label}</StepLabel>
      </Step>
    );
  })}
</Stepper>
)}
<FormControl>
<DynamicStep
  values={memoizedFormValues}
  setValues={setFormValues}
  activeStep={activeStep}
  setActiveStep={setActiveStep}
  medicationsList={medicationsList}
  insuranceDataList={insuranceDataList}
  isMedicareOnly={isMedicareOnly}
/>
</FormControl>
</Stack>
);
}

const MemoizedFormStepper = React.memo(FormStepper);
export default MemoizedFormStepper;
